export default {
  Account: {
    en: 'Account',
    ja: 'Account',
    et: 'Account',
    lt: 'Account',
    ch: 'Account',
    ph: 'Account',
  },
  'Account Status': {
    en: 'Account Status',
    ja: 'Account Status',
    et: 'Account Status',
    lt: 'Account Status',
    ch: 'Account Status',
    ph: 'Account Status',
  },
  ACTIVE: {
    en: 'ACTIVE',
    ja: 'ACTIVE',
    et: 'ACTIVE',
    lt: 'ACTIVE',
    ch: 'ACTIVE',
    ph: 'ACTIVE',
  },
  Add: {
    en: 'Add',
    ja: 'Add',
    et: 'Add',
    lt: 'Add',
    ch: 'Add',
    ph: 'Add',
  },
  Admin: {
    en: 'Admin',
    ja: 'Admin',
    et: 'Admin',
    lt: 'Admin',
    ch: 'Admin',
    ph: 'Admin',
  },
  'Admin Notes': {
    en: 'Admin Notes',
    ja: 'Admin Notes',
    et: 'Admin Notes',
    lt: 'Admin Notes',
    ch: 'Admin Notes',
    ph: 'Admin Notes',
  },
  Ago: {
    en: 'Ago',
    ja: 'Ago',
    et: 'Ago',
    lt: 'Ago',
    ch: 'Ago',
    ph: 'Ago',
  },
  All: {
    en: 'All',
    ja: '全て',
    et: 'Kõik',
    lt: 'All',
    ch: 'All',
    ph: 'All',
  },
  'All Members': {
    en: 'All Members',
    ja: 'All Members',
    et: 'All Members',
    lt: 'All Members',
    ch: 'All Members',
    ph: 'All Members',
  },
  'All Staff': {
    en: 'All Staff',
    ja: 'All Staff',
    et: 'All Staff',
    lt: 'All Staff',
    ch: 'All Staff',
    ph: 'All Staff',
  },
  Amount: {
    en: 'Amount',
    ja: 'Amount',
    et: 'Amount',
    lt: 'Amount',
    ch: 'Amount',
    ph: 'Amount',
  },
  'Amount Added:': {
    en: 'Amount Added:',
    ja: 'Amount Added:',
    et: 'Amount Added:',
    lt: 'Amount Added:',
    ch: 'Amount Added:',
    ph: 'Amount Added:',
  },
  'Amount Deducted:': {
    en: 'Amount Deducted:',
    ja: 'Amount Deducted:',
    et: 'Amount Deducted:',
    lt: 'Amount Deducted:',
    ch: 'Amount Deducted:',
    ph: 'Amount Deducted:',
  },
  'Are you sure you want to ban this user?': {
    en: 'Are you sure you want to ban this user?',
    ja: 'Are you sure you want to ban this user?',
    et: 'Are you sure you want to ban this user?',
    lt: 'Are you sure you want to ban this user?',
    ch: 'Are you sure you want to ban this user?',
    ph: 'Are you sure you want to ban this user?',
  },
  'Are you sure you want to delete this user?': {
    en: 'Are you sure you want to delete this user?',
    ja: 'Are you sure you want to delete this user?',
    et: 'Are you sure you want to delete this user?',
    lt: 'Are you sure you want to delete this user?',
    ch: 'Are you sure you want to delete this user?',
    ph: 'Are you sure you want to delete this user?',
  },
  'Are you sure you want to unban this user?': {
    en: 'Are you sure you want to unban this user?',
    ja: 'Are you sure you want to unban this user?',
    et: 'Are you sure you want to unban this user?',
    lt: 'Are you sure you want to unban this user?',
    ch: 'Are you sure you want to unban this user?',
    ph: 'Are you sure you want to unban this user?',
  },
  ASC: {
    en: 'ASC',
    ja: 'ASC',
    et: 'ASC',
    lt: 'ASC',
    ch: 'ASC',
    ph: 'ASC',
  },
  Award: {
    en: 'Award',
    ja: 'Award',
    et: 'Award',
    lt: 'Award',
    ch: 'Award',
    ph: 'Award',
  },
  'Award Badge': {
    en: 'Award Badge',
    ja: 'Award Badge',
    et: 'Award Badge',
    lt: 'Award Badge',
    ch: 'Award Badge',
    ph: 'Award Badge',
  },
  'Award Challenge': {
    en: 'Award Challenge',
    ja: 'Award Challenge',
    et: 'Award Challenge',
    lt: 'Award Challenge',
    ch: 'Award Challenge',
    ph: 'Award Challenge',
  },
  'Award user a badge': {
    en: 'Award user a badge',
    ja: 'Award user a badge',
    et: 'Award user a badge',
    lt: 'Award user a badge',
    ch: 'Award user a badge',
    ph: 'Award user a badge',
  },
  'Award user a challenge': {
    en: 'Award user a challenge',
    ja: 'Award user a challenge',
    et: 'Award user a challenge',
    lt: 'Award user a challenge',
    ch: 'Award user a challenge',
    ph: 'Award user a challenge',
  },
  'Awarded badges': {
    en: 'Awarded badges',
    ja: 'Awarded badges',
    et: 'Awarded badges',
    lt: 'Awarded badges',
    ch: 'Awarded badges',
    ph: 'Awarded badges',
  },
  'Awarded challenges': {
    en: 'Awarded challenges',
    ja: 'Awarded challenges',
    et: 'Awarded challenges',
    lt: 'Awarded challenges',
    ch: 'Awarded challenges',
    ph: 'Awarded challenges',
  },
  Back: {
    en: 'Back',
    ja: 'Back',
    et: 'Back',
    lt: 'Back',
    ch: 'Back',
    ph: 'Back',
  },
  'Badge awarded': {
    en: 'Badge awarded',
    ja: 'Badge awarded',
    et: 'Badge awarded',
    lt: 'Badge awarded',
    ch: 'Badge awarded',
    ph: 'Badge awarded',
  },
  'Challenge awarded': {
    en: 'Challenge awarded',
    ja: 'Challenge awarded',
    et: 'Challenge awarded',
    lt: 'Challenge awarded',
    ch: 'Challenge awarded',
    ph: 'Challenge awarded',
  },
  'Badge removed': {
    en: 'Badge removed',
    ja: 'Badge removed',
    et: 'Badge removed',
    lt: 'Badge removed',
    ch: 'Badge removed',
    ph: 'Badge removed',
  },
  Badges: {
    en: 'Badges',
    ja: 'バッジ',
    et: 'Märgid',
    lt: 'Badges',
    ch: 'Badges',
    ph: 'Badges',
  },
  'Ban User': {
    en: 'Ban User',
    ja: 'Ban User',
    et: 'Ban User',
    lt: 'Ban User',
    ch: 'Ban User',
    ph: 'Ban User',
  },
  Banned: {
    en: 'Banned',
    ja: 'Banned',
    et: 'Banned',
    lt: 'Banned',
    ch: 'Banned',
    ph: 'Banned',
  },
  Branch: {
    en: 'Branch',
    ja: 'Branch',
    et: 'Branch',
    lt: 'Branch',
    ch: 'Branch',
    ph: 'Branch',
  },
  BANNED: {
    en: 'BANNED',
    ja: 'BANNED',
    et: 'BANNED',
    lt: 'BANNED',
    ch: 'BANNED',
    ph: 'BANNED',
  },
  'Challenge removed': {
    en: 'Challenge removed',
    ja: 'Challenge removed',
    et: 'Challenge removed',
    lt: 'Challenge removed',
    ch: 'Challenge removed',
    ph: 'Challenge removed',
  },
  'Change Password': {
    en: 'Change Password',
    ja: 'Change Password',
    et: 'Change Password',
    lt: 'Change Password',
    ch: 'Change Password',
    ph: 'Change Password',
  },
  'Check In': {
    en: 'Check In',
    ja: 'Check In',
    et: 'Check In',
    lt: 'Check In',
    ch: 'Check In',
    ph: 'Check In',
  },
  'Welcome to the wonderful world of Vivistop!': {
    en: 'Welcome to the wonderful world of Vivistop!',
    ja: 'Welcome to the wonderful world of Vivistop!',
    et: 'Welcome to the wonderful world of Vivistop!',
    lt: 'Welcome to the wonderful world of Vivistop!',
    ch: 'Welcome to the wonderful world of Vivistop!',
    ph: 'Welcome to the wonderful world of Vivistop!',
  },
  'Choose a badge': {
    en: 'Choose a badge',
    ja: 'Choose a badge',
    et: 'Choose a badge',
    lt: 'Choose a badge',
    ch: 'Choose a badge',
    ph: 'Choose a badge',
  },
  'Choose a badge category (optional)': {
    en: 'Choose a badge category (optional)',
    ja: 'Choose a badge category (optional)',
    et: 'Choose a badge category (optional)',
    lt: 'Choose a badge category (optional)',
    ch: 'Choose a badge category (optional)',
    ph: 'Choose a badge category (optional)',
  },
  'Choose a challenge': {
    en: 'Choose a challenge',
    ja: 'Choose a challenge',
    et: 'Choose a challenge',
    lt: 'Choose a challenge',
    ch: 'Choose a challenge',
    ph: 'Choose a challenge',
  },
  'Choose here': {
    en: 'Choose here',
    ja: 'Choose here',
    et: 'Choose here',
    lt: 'Choose here',
    ch: 'Choose here',
    ph: 'Choose here',
  },
  'Click on button below to update the wallet balance.': {
    en: 'Click on button below to update the wallet balance.',
    ja: 'Click on button below to update the wallet balance.',
    et: 'Click on button below to update the wallet balance.',
    lt: 'Click on button below to update the wallet balance.',
    ch: 'Click on button below to update the wallet balance.',
    ph: 'Click on button below to update the wallet balance.',
  },
  Continue: {
    en: 'Continue',
    ja: 'Continue',
    et: 'Continue',
    lt: 'Continue',
    ch: 'Continue',
    ph: 'Continue',
  },
  'Create User before adding badges': {
    en: 'Create User before adding badges',
    ja: 'Create User before adding badges',
    et: 'Create User before adding badges',
    lt: 'Create User before adding badges',
    ch: 'Create User before adding badges',
    ph: 'Create User before adding badges',
  },
  'Create User before checking user booking quota': {
    en: 'Create User before checking user booking quota',
    ja: 'Create User before checking user booking quota',
    et: 'Create User before checking user booking quota',
    lt: 'Create User before checking user booking quota',
    ch: 'Create User before checking user booking quota',
    ph: 'Create User before checking user booking quota',
  },
  'Create User before adding challenges': {
    en: 'Create User before adding challenges',
    ja: 'Create User before adding challenges',
    et: 'Create User before adding challenges',
    lt: 'Create User before adding challenges',
    ch: 'Create User before adding challenges',
    ph: 'Create User before adding challenges',
  },
  'Created At': {
    en: 'Created At',
    ja: 'Created At',
    et: 'Created At',
    lt: 'Created At',
    ch: 'Created At',
    ph: 'Created At',
  },
  'Created Date': {
    en: 'Created Date',
    ja: '作成日',
    et: 'Loomise kuupäev',
    lt: 'Created Date',
    ch: 'Created Date',
    ph: 'Created Date',
  },
  'Create Wallet': {
    en: 'Create Wallet',
    ja: 'Create Wallet',
    et: 'Create Wallet',
    lt: 'Create Wallet',
    ch: 'Create Wallet',
    ph: 'Create Wallet',
  },
  'Create User Wallet': {
    en: 'Create User Wallet',
    ja: 'Create User Wallet',
    et: 'Create User Wallet',
    lt: 'Create User Wallet',
    ch: 'Create User Wallet',
    ph: 'Create User Wallet',
  },
  "Creator's Username": {
    en: "Creator's Username",
    ja: "Creator's Username",
    et: "Creator's Username",
    lt: "Creator's Username",
    ch: "Creator's Username",
    ph: "Creator's Username",
  },
  Crew: {
    en: 'Crew',
    ja: 'Crew',
    et: 'Crew',
    lt: 'Crew',
    ch: 'Crew',
    ph: 'Crew',
  },
  'Crew Invite': {
    en: 'Crew Invite',
    ja: 'Crew Invite',
    et: 'Crew Invite',
    lt: 'Crew Invite',
    ch: 'Crew Invite',
    ph: 'Crew Invite',
  },
  "Current month's consumed quota": {
    en: "Current month's consumed quota",
    ja: "Current month's consumed quota",
    et: "Current month's consumed quota",
    lt: "Current month's consumed quota",
    ch: "Current month's consumed quota",
    ph: "Current month's consumed quota",
  },
  DESC: {
    en: 'DESC',
    ja: 'DESC',
    et: 'DESC',
    lt: 'DESC',
    ch: 'DESC',
    ph: 'DESC',
  },
  'Date of Birth': {
    en: 'Date of Birth',
    ja: 'Date of Birth',
    et: 'Date of Birth',
    lt: 'Date of Birth',
    ch: 'Date of Birth',
    ph: 'Date of Birth',
  },
  Day: {
    en: 'Day',
    ja: 'Day',
    et: 'Day',
    lt: 'Day',
    ch: 'Day',
    ph: 'Day',
  },
  Days: {
    en: 'Days',
    ja: 'Days',
    et: 'Days',
    lt: 'Days',
    ch: 'Days',
    ph: 'Days',
  },
  Deduct: {
    en: 'Deduct',
    ja: 'Deduct',
    et: 'Deduct',
    lt: 'Deduct',
    ch: 'Deduct',
    ph: 'Deduct',
  },
  'Delete User': {
    en: 'Delete User',
    ja: 'Delete User',
    et: 'Delete User',
    lt: 'Delete User',
    ch: 'Delete User',
    ph: 'Delete User',
  },
  Email: {
    en: 'Email',
    ja: 'メール',
    et: 'E-maili aadress',
    lt: 'Email',
    ch: 'Email',
    ph: 'Email',
  },
  emailVerifySkipConfirm: {
    en: 'Are you sure you want to skip verification for this user?',
    ja: 'Are you sure you want to skip verification for this user?',
    et: 'Are you sure you want to skip verification for this user?',
    lt: 'Are you sure you want to skip verification for this user?',
    ch: 'Are you sure you want to skip verification for this user?',
    ph: 'Are you sure you want to skip verification for this user?',
  },
  emailVerifyRerequestConfirm: {
    en: 'Are you sure you want to re-request verification from this user?',
    ja: 'Are you sure you want to re-request verification from this user?',
    et: 'Are you sure you want to re-request verification from this user?',
    lt: 'Are you sure you want to re-request verification from this user?',
    ch: 'Are you sure you want to re-request verification from this user?',
    ph: 'Are you sure you want to re-request verification from this user?',
  },
  'Email Not Verified': {
    en: 'Email Not Verified',
    ja: 'Email Not Verified',
    et: 'Email Not Verified',
    lt: 'Email Not Verified',
    ch: 'Email Not Verified',
    ph: 'Email Not Verified',
  },
  'Email Verification Skipped': {
    en: 'Email Verification Skipped',
    ja: 'Email Verification Skipped',
    et: 'Email Verification Skipped',
    lt: 'Email Verification Skipped',
    ch: 'Email Verification Skipped',
    ph: 'Email Verification Skipped',
  },
  'Email Verification Reset': {
    en: 'Email Verification Reset',
    ja: 'Email Verification Reset',
    et: 'Email Verification Reset',
    lt: 'Email Verification Reset',
    ch: 'Email Verification Reset',
    ph: 'Email Verification Reset',
  },
  'Email Verified': {
    en: 'Email Verified',
    ja: 'Email Verified',
    et: 'Email Verified',
    lt: 'Email Verified',
    ch: 'Email Verified',
    ph: 'Email Verified',
  },
  'Event Quota': {
    en: 'Event Quota',
    ja: 'Event Quota',
    et: 'Event Quota',
    lt: 'Event Quota',
    ch: 'Event Quota',
    ph: 'Event Quota',
  },
  Export: {
    en: 'Export',
    ja: 'Export',
    et: 'Export',
    lt: 'Export',
    ch: 'Export',
    ph: 'Export',
  },
  explorer: {
    en: 'Explorer',
    ja: 'Explorer',
    et: 'Explorer',
    lt: 'Explorer',
    ch: 'Explorer',
    ph: 'Explorer',
  },
  'Fail to fetch data': {
    en: 'Fail to fetch data',
    ja: 'Fail to fetch data',
    et: 'Fail to fetch data',
    lt: 'Fail to fetch data',
    ch: 'Fail to fetch data',
    ph: 'Fail to fetch data',
  },
  'Family Name': {
    en: 'Family Name',
    ja: 'Family Name',
    et: 'Family Name',
    lt: 'Family Name',
    ch: 'Family Name',
    ph: 'Family Name',
  },
  'Feedback for the session (if any)': {
    en: 'Feedback for the session (if any)',
    ja: 'Feedback for the session (if any)',
    et: 'Feedback for the session (if any)',
    lt: 'Feedback for the session (if any)',
    ch: 'Feedback for the session (if any)',
    ph: 'Feedback for the session (if any)',
  },
  Female: {
    en: 'Female',
    ja: 'Female',
    et: 'Female',
    lt: 'Female',
    ch: 'Female',
    ph: 'Female',
  },
  'File is too large. Max File size: 1MB': {
    en: 'File is too large. Max File size: 1MB',
    ja: 'File is too large. Max File size: 1MB',
    et: 'File is too large. Max File size: 1MB',
    lt: 'File is too large. Max File size: 1MB',
    ch: 'File is too large. Max File size: 1MB',
    ph: 'File is too large. Max File size: 1MB',
  },
  Gender: {
    en: 'Gender',
    ja: 'Gender',
    et: 'Gender',
    lt: 'Gender',
    ch: 'Gender',
    ph: 'Gender',
  },
  'Given Name': {
    en: 'Given Name',
    ja: 'Given Name',
    et: 'Given Name',
    lt: 'Given Name',
    ch: 'Given Name',
    ph: 'Given Name',
  },
  "Guardian's Email": {
    en: "Guardian's Email",
    ja: "Guardian's Email",
    et: "Guardian's Email",
    lt: "Guardian's Email",
    ch: "Guardian's Email",
    ph: "Guardian's Email",
  },
  "Guardian's Phone Number": {
    en: "Guardian's Phone Number",
    ja: "Guardian's Phone Number",
    et: "Guardian's Phone Number",
    lt: "Guardian's Phone Number",
    ch: "Guardian's Phone Number",
    ph: "Guardian's Phone Number",
  },
  Hour: {
    en: 'Hour',
    ja: 'Hour',
    et: 'Hour',
    lt: 'Hour',
    ch: 'Hour',
    ph: 'Hour',
  },
  Hours: {
    en: 'Hours',
    ja: 'Hours',
    et: 'Hours',
    lt: 'Hours',
    ch: 'Hours',
    ph: 'Hours',
  },
  'How was the session?': {
    en: 'How was the session?',
    ja: 'How was the session?',
    et: 'How was the session?',
    lt: 'How was the session?',
    ch: 'How was the session?',
    ph: 'How was the session?',
  },
  INACTIVE: {
    en: 'INACTIVE',
    ja: 'INACTIVE',
    et: 'INACTIVE',
    lt: 'INACTIVE',
    ch: 'INACTIVE',
    ph: 'INACTIVE',
  },
  Intern: {
    en: 'Intern',
    ja: 'Intern',
    et: 'Intern',
    lt: 'Intern',
    ch: 'Intern',
    ph: 'Intern',
  },
  'Last Active': {
    en: 'Last Active',
    ja: 'Last Active',
    et: 'Last Active',
    lt: 'Last Active',
    ch: 'Last Active',
    ph: 'Last Active',
  },
  'Loading...': {
    en: 'Loading...',
    ja: 'Loading...',
    et: 'Loading...',
    lt: 'Loading...',
    ch: 'Loading...',
    ph: 'Loading...',
  },
  'Looking around': {
    en: 'Looking around',
    ja: 'Looking around',
    et: 'Looking around',
    lt: 'Looking around',
    ch: 'Looking around',
    ph: 'Looking around',
  },
  Male: {
    en: 'Male',
    ja: 'Male',
    et: 'Male',
    lt: 'Male',
    ch: 'Male',
    ph: 'Male',
  },
  'Minimum 3 characters required!': {
    en: 'Minimum 3 characters required!',
    ja: 'Minimum 3 characters required!',
    et: 'Minimum 3 characters required!',
    lt: 'Minimum 3 characters required!',
    ch: 'Minimum 3 characters required!',
    ph: 'Minimum 3 characters required!',
  },
  Minute: {
    en: 'Minute',
    ja: 'Minute',
    et: 'Minute',
    lt: 'Minute',
    ch: 'Minute',
    ph: 'Minute',
  },
  Minutes: {
    en: 'Minutes',
    ja: 'Minutes',
    et: 'Minutes',
    lt: 'Minutes',
    ch: 'Minutes',
    ph: 'Minutes',
  },
  Name: {
    en: 'Name',
    ja: 'Name',
    et: 'Name',
    lt: 'Name',
    ch: 'Name',
    ph: 'Name',
  },
  'New User': {
    en: 'New User',
    ja: 'New User',
    et: 'New User',
    lt: 'New User',
    ch: 'New User',
    ph: 'New User',
  },
  'Name of Siblings who are VIVINAUTs': {
    en: 'Name of Siblings who are VIVINAUTs',
    ja: 'Name of Siblings who are VIVINAUTs',
    et: 'Name of Siblings who are VIVINAUTs',
    lt: 'Name of Siblings who are VIVINAUTs',
    ch: 'Name of Siblings who are VIVINAUTs',
    ph: 'Name of Siblings who are VIVINAUTs',
  },
  'No claimed rewards': {
    en: 'No claimed rewards',
    ja: 'No claimed rewards',
    et: 'No claimed rewards',
    lt: 'No claimed rewards',
    ch: 'No claimed rewards',
    ph: 'No claimed rewards',
  },
  'No Results': {
    en: 'No Results',
    ja: '結果がありません',
    et: 'Tulemused puuduvad',
    lt: 'No Results',
    ch: 'No Results',
    ph: 'No Results',
  },
  'No results found!': {
    en: 'No results found!',
    ja: 'No results found!',
    et: 'No results found!',
    lt: 'No results found!',
    ch: 'No results found!',
    ph: 'No results found!',
  },
  'No user found!': {
    en: 'No user found!',
    ja: 'No user found!',
    et: 'No user found!',
    lt: 'No user found!',
    ch: 'No user found!',
    ph: 'No user found!',
  },
  'Non-binary': {
    en: 'Non-binary',
    ja: 'Non-binary',
    et: 'Non-binary',
    lt: 'Non-binary',
    ch: 'Non-binary',
    ph: 'Non-binary',
  },
  Now: {
    en: 'Now',
    ja: 'Now',
    et: 'Now',
    lt: 'Now',
    ch: 'Now',
    ph: 'Now',
  },
  Other: {
    en: 'Other',
    ja: 'Other',
    et: 'Other',
    lt: 'Other',
    ch: 'Other',
    ph: 'Other',
  },
  Others: {
    en: 'Others',
    ja: 'Others',
    et: 'Others',
    lt: 'Others',
    ch: 'Others',
    ph: 'Others',
  },
  Password: {
    en: 'Password',
    ja: 'パスワード',
    et: 'Parool',
    lt: 'Password',
    ch: 'Password',
    ph: 'Password',
  },
  'Password (leave blank for no changes)': {
    en: 'Password (leave blank for no changes)',
    ja: 'Password (leave blank for no changes)',
    et: 'Password (leave blank for no changes)',
    lt: 'Password (leave blank for no changes)',
    ch: 'Password (leave blank for no changes)',
    ph: 'Password (leave blank for no changes)',
  },
  'Please add a comma between each sibling': {
    en: 'Please add a comma between each sibling',
    ja: 'Please add a comma between each sibling',
    et: 'Please add a comma between each sibling',
    lt: 'Please add a comma between each sibling',
    ch: 'Please add a comma between each sibling',
    ph: 'Please add a comma between each sibling',
  },
  'Preferred Name': {
    en: 'Preferred Name',
    ja: 'Preferred Name',
    et: 'Preferred Name',
    lt: 'Preferred Name',
    ch: 'Preferred Name',
    ph: 'Preferred Name',
  },
  'Prefer not to respond': {
    en: 'Prefer not to respond',
    ja: 'Prefer not to respond',
    et: 'Prefer not to respond',
    lt: 'Prefer not to respond',
    ch: 'Prefer not to respond',
    ph: 'Prefer not to respond',
  },
  'Phone Number': {
    en: 'Phone Number',
    ja: 'Phone Number',
    et: 'Phone Number',
    lt: 'Phone Number',
    ch: 'Phone Number',
    ph: 'Phone Number',
  },
  "Please include the dash '-'": {
    en: "Please include the dash '-'",
    ja: "Please include the dash '-'",
    et: "Please include the dash '-'",
    lt: "Please include the dash '-'",
    ch: "Please include the dash '-'",
    ph: "Please include the dash '-'",
  },
  'Please leave your email address if you would like us to contact you in the future': {
    en: 'Please leave your email address if you would like us to contact you in the future',
    ja: 'Please leave your email address if you would like us to contact you in the future',
    et: 'Please leave your email address if you would like us to contact you in the future',
    lt: 'Please leave your email address if you would like us to contact you in the future',
    ch: 'Please leave your email address if you would like us to contact you in the future',
    ph: 'Please leave your email address if you would like us to contact you in the future',
  },
  'Please select a badge to award': {
    en: 'Please select a badge to award',
    ja: 'Please select a badge to award',
    et: 'Please select a badge to award',
    lt: 'Please select a badge to award',
    ch: 'Please select a badge to award',
    ph: 'Please select a badge to award',
  },
  'Please select a challenge to award': {
    en: 'Please select a challenge to award',
    ja: 'Please select a challenge to award',
    et: 'Please select a challenge to award',
    lt: 'Please select a challenge to award',
    ch: 'Please select a challenge to award',
    ph: 'Please select a challenge to award',
  },
  Profile: {
    en: 'Profile',
    ja: 'Profile',
    et: 'Profile',
    lt: 'Profile',
    ch: 'Profile',
    ph: 'Profile',
  },
  'Profile Description': {
    en: 'Profile Description',
    ja: 'Profile Description',
    et: 'Profile Description',
    lt: 'Profile Description',
    ch: 'Profile Description',
    ph: 'Profile Description',
  },
  'Profile Details': {
    en: 'Profile Details',
    ja: 'Profile Details',
    et: 'Profile Details',
    lt: 'Profile Details',
    ch: 'Profile Details',
    ph: 'Profile Details',
  },
  'Profile saved!': {
    en: 'Profile saved!',
    ja: 'Profile saved!',
    et: 'Profile saved!',
    lt: 'Profile saved!',
    ch: 'Profile saved!',
    ph: 'Profile saved!',
  },
  'Reason to award (optional)': {
    en: 'Reason to award (optional)',
    ja: 'Reason to award (optional)',
    et: 'Reason to award (optional)',
    lt: 'Reason to award (optional)',
    ch: 'Reason to award (optional)',
    ph: 'Reason to award (optional)',
  },
  'Remove badge for this user?': {
    en: 'Remove badge for this user?',
    ja: 'Remove badge for this user?',
    et: 'Remove badge for this user?',
    lt: 'Remove badge for this user?',
    ch: 'Remove badge for this user?',
    ph: 'Remove badge for this user?',
  },
  'Remove challenge for this user?': {
    en: 'Remove challenge for this user?',
    ja: 'Remove challenge for this user?',
    et: 'Remove challenge for this user?',
    lt: 'Remove challenge for this user?',
    ch: 'Remove challenge for this user?',
    ph: 'Remove challenge for this user?',
  },
  'Re-request Verification': {
    en: 'Re-request Verification',
    ja: 'Re-request Verification',
    et: 'Re-request Verification',
    lt: 'Re-request Verification',
    ch: 'Re-request Verification',
    ph: 'Re-request Verification',
  },
  Restricted: {
    en: 'Restricted',
    ja: 'Restricted',
    et: 'Restricted',
    lt: 'Restricted',
    ch: 'Restricted',
    ph: 'Restricted',
  },
  RESTRICTED: {
    en: 'RESTRICTED',
    ja: 'RESTRICTED',
    et: 'RESTRICTED',
    lt: 'RESTRICTED',
    ch: 'RESTRICTED',
    ph: 'RESTRICTED',
  },
  'Restricted and Banned users are unable to login': {
    en: 'Restricted and Banned users are unable to login',
    ja: 'Restricted and Banned users are unable to login',
    et: 'Restricted and Banned users are unable to login',
    lt: 'Restricted and Banned users are unable to login',
    ch: 'Restricted and Banned users are unable to login',
    ph: 'Restricted and Banned users are unable to login',
  },
  'Reward Amount': {
    en: 'Reward Amount',
    ja: 'Reward Amount',
    et: 'Reward Amount',
    lt: 'Reward Amount',
    ch: 'Reward Amount',
    ph: 'Reward Amount',
  },
  'Reward Code': {
    en: 'Reward Code',
    ja: 'Reward Code',
    et: 'Reward Code',
    lt: 'Reward Code',
    ch: 'Reward Code',
    ph: 'Reward Code',
  },
  'Rewards Claimed': {
    en: 'Rewards Claimed',
    ja: 'Rewards Claimed',
    et: 'Rewards Claimed',
    lt: 'Rewards Claimed',
    ch: 'Rewards Claimed',
    ph: 'Rewards Claimed',
  },
  Save: {
    en: 'Save',
    ja: '保存',
    et: 'Salvesta',
    lt: 'Save',
    ch: 'Save',
    ph: 'Save',
  },
  Search: {
    en: 'Search',
    ja: '探す',
    et: 'Otsing',
    lt: 'Search',
    ch: 'Search',
    ph: 'Search',
  },
  'Search Users': {
    en: 'Search Users',
    ja: 'Search Users',
    et: 'Search Users',
    lt: 'Search Users',
    ch: 'Search Users',
    ph: 'Search Users',
  },
  Second: {
    en: 'Second',
    ja: 'Second',
    et: 'Second',
    lt: 'Second',
    ch: 'Second',
    ph: 'Second',
  },
  Seconds: {
    en: 'Seconds',
    ja: 'Seconds',
    et: 'Seconds',
    lt: 'Seconds',
    ch: 'Seconds',
    ph: 'Seconds',
  },
  "Second Guardian's Email": {
    en: "Second Guardian's Email",
    ja: "Second Guardian's Email",
    et: "Second Guardian's Email",
    lt: "Second Guardian's Email",
    ch: "Second Guardian's Email",
    ph: "Second Guardian's Email",
  },
  "Second Guardian's Phone Number": {
    en: "Second Guardian's Phone Number",
    ja: "Second Guardian's Phone Number",
    et: "Second Guardian's Phone Number",
    lt: "Second Guardian's Phone Number",
    ch: "Second Guardian's Phone Number",
    ph: "Second Guardian's Phone Number",
  },
  'Select an option': {
    en: 'Select an option',
    ja: 'Select an option',
    et: 'Select an option',
    lt: 'Select an option',
    ch: 'Select an option',
    ph: 'Select an option',
  },
  'Skip Verification': {
    en: 'Skip Verification',
    ja: 'Skip Verification',
    et: 'Skip Verification',
    lt: 'Skip Verification',
    ch: 'Skip Verification',
    ph: 'Skip Verification',
  },
  'Send Username and Password to User Email': {
    en: 'Send Username and Password to User Email',
    ja: 'Send Username and Password to User Email',
    et: 'Send Username and Password to User Email',
    lt: 'Send Username and Password to User Email',
    ch: 'Send Username and Password to User Email',
    ph: 'Send Username and Password to User Email',
  },
  passwordWarning: {
    en: 'Send passwords only if they are randomly generated to ensure account security.',
    ja: 'Send passwords only if they are randomly generated to ensure account security.',
    et: 'Send passwords only if they are randomly generated to ensure account security.',
    lt: 'Send passwords only if they are randomly generated to ensure account security.',
    ch: 'Send passwords only if they are randomly generated to ensure account security.',
    ph: 'Send passwords only if they are randomly generated to ensure account security.',
  },
  'Staff Roles': {
    en: 'Staff Roles',
    ja: 'スタッフの役割',
    et: 'Töötajate rollid',
    lt: 'Staff Roles',
    ch: 'Staff Roles',
    ph: 'Staff Roles',
  },
  Status: {
    en: 'Status',
    ja: 'Status',
    et: 'Status',
    lt: 'Status',
    ch: 'Status',
    ph: 'Status',
  },
  Submit: {
    en: 'Submit',
    ja: 'Submit',
    et: 'Submit',
    lt: 'Submit',
    ch: 'Submit',
    ph: 'Submit',
  },
  SUSPENDED: {
    en: 'SUSPENDED',
    ja: 'SUSPENDED',
    et: 'SUSPENDED',
    lt: 'SUSPENDED',
    ch: 'SUSPENDED',
    ph: 'SUSPENDED',
  },
  'Thank you for joining us today,': {
    en: 'Thank you for joining us today,',
    ja: 'Thank you for joining us today,',
    et: 'Thank you for joining us today,',
    lt: 'Thank you for joining us today,',
    ch: 'Thank you for joining us today,',
    ph: 'Thank you for joining us today,',
  },
  'This is a new user': {
    en: 'This is a new user',
    ja: 'This is a new user',
    et: 'This is a new user',
    lt: 'This is a new user',
    ch: 'This is a new user',
    ph: 'This is a new user',
  },
  'This is not me': {
    en: 'This is not me',
    ja: 'This is not me',
    et: 'This is not me',
    lt: 'This is not me',
    ch: 'This is not me',
    ph: 'This is not me',
  },
  'This user has not claimed any rewards.': {
    en: 'This user has not claimed any rewards.',
    ja: 'This user has not claimed any rewards.',
    et: 'This user has not claimed any rewards.',
    lt: 'This user has not claimed any rewards.',
    ch: 'This user has not claimed any rewards.',
    ph: 'This user has not claimed any rewards.',
  },
  'to wallet': {
    en: 'to wallet',
    ja: 'to wallet',
    et: 'to wallet',
    lt: 'to wallet',
    ch: 'to wallet',
    ph: 'to wallet',
  },
  'Unban User': {
    en: 'Unban User',
    ja: 'Unban User',
    et: 'Unban User',
    lt: 'Unban User',
    ch: 'Unban User',
    ph: 'Unban User',
  },
  'Updated At': {
    en: 'Updated At',
    ja: 'Updated At',
    et: 'Updated At',
    lt: 'Updated At',
    ch: 'Updated At',
    ph: 'Updated At',
  },
  'Upload Cover Picture': {
    en: 'Upload Cover Picture',
    ja: 'Upload Cover Picture',
    et: 'Upload Cover Picture',
    lt: 'Upload Cover Picture',
    ch: 'Upload Cover Picture',
    ph: 'Upload Cover Picture',
  },
  'Upload Profile Picture': {
    en: 'Upload Profile Picture',
    ja: 'Upload Profile Picture',
    et: 'Upload Profile Picture',
    lt: 'Upload Profile Picture',
    ch: 'Upload Profile Picture',
    ph: 'Upload Profile Picture',
  },
  Username: {
    en: 'Username',
    ja: 'ユーザー名',
    et: 'Kasutajanimi',
    lt: 'Username',
    ch: 'Username',
    ph: 'Username',
  },
  Users: {
    en: 'Users',
    ja: 'ユーザー',
    et: 'Kasutajad',
    lt: 'Users',
    ch: 'Users',
    ph: 'Users',
  },
  'User Badges': {
    en: 'User Badges',
    ja: 'User Badges',
    et: 'User Badges',
    lt: 'User Badges',
    ch: 'User Badges',
    ph: 'User Badges',
  },
  'User Info': {
    en: 'User Info',
    ja: 'User Info',
    et: 'User Info',
    lt: 'User Info',
    ch: 'User Info',
    ph: 'User Info',
  },
  'User has not been awarded badge yet.': {
    en: 'User has not been awarded badge yet.',
    ja: 'User has not been awarded badge yet.',
    et: 'User has not been awarded badge yet.',
    lt: 'User has not been awarded badge yet.',
    ch: 'User has not been awarded badge yet.',
    ph: 'User has not been awarded badge yet.',
  },
  'User has not been awarded challenge yet.': {
    en: 'User has not been awarded challenge yet.',
    ja: 'User has not been awarded challenge yet.',
    et: 'User has not been awarded challenge yet.',
    lt: 'User has not been awarded challenge yet.',
    ch: 'User has not been awarded challenge yet.',
    ph: 'User has not been awarded challenge yet.',
  },
  'User Status': {
    en: 'User Status',
    ja: 'User Status',
    et: 'User Status',
    lt: 'User Status',
    ch: 'User Status',
    ph: 'User Status',
  },
  'Verify User Email': {
    en: 'Verify User Email',
    ja: 'Verify User Email',
    et: 'Verify User Email',
    lt: 'Verify User Email',
    ch: 'Verify User Email',
    ph: 'Verify User Email',
  },
  'View Wallet': {
    en: 'View Wallet',
    ja: 'View Wallet',
    et: 'View Wallet',
    lt: 'View Wallet',
    ch: 'View Wallet',
    ph: 'View Wallet',
  },
  Visitor: {
    en: 'Visitor',
    ja: 'Visitor',
    et: 'Visitor',
    lt: 'Visitor',
    ch: 'Visitor',
    ph: 'Visitor',
  },
  "Visitor's Name*": {
    en: "Visitor's Name*",
    ja: "Visitor's Name*",
    et: "Visitor's Name*",
    lt: "Visitor's Name*",
    ch: "Visitor's Name*",
    ph: "Visitor's Name*",
  },
  'Vivicoin Wallet': {
    en: 'Vivicoin Wallet',
    ja: 'Vivicoin Wallet',
    et: 'Vivicoin Wallet',
    lt: 'Vivicoin Wallet',
    ch: 'Vivicoin Wallet',
    ph: 'Vivicoin Wallet',
  },
  Vivinaut: {
    en: 'Vivinaut',
    ja: 'Vivinaut',
    et: 'Vivinaut',
    lt: 'Vivinaut',
    ch: 'Vivinaut',
    ph: 'Vivinaut',
  },
  vivinaut: {
    en: 'vivinaut',
    ja: 'vivinaut',
    et: 'vivinaut',
    lt: 'vivinaut',
    ch: 'vivinaut',
    ph: 'vivinaut',
  },
  "VIVINAUT's Given Name*": {
    en: "VIVINAUT's Given Name*",
    ja: "VIVINAUT's Given Name*",
    et: "VIVINAUT's Given Name*",
    lt: "VIVINAUT's Given Name*",
    ch: "VIVINAUT's Given Name*",
    ph: "VIVINAUT's Given Name*",
  },
  'VIVISTOP Branch': {
    en: 'VIVISTOP Branch',
    ja: 'VIVISTOP Branch',
    et: 'VIVISTOP Branch',
    lt: 'VIVISTOP Branch',
    ch: 'VIVISTOP Branch',
    ph: 'VIVISTOP Branch',
  },
  Wallet: {
    en: 'Wallet',
    ja: 'Wallet',
    et: 'Wallet',
    lt: 'Wallet',
    ch: 'Wallet',
    ph: 'Wallet',
  },
  'Wallet Balance': {
    en: 'Wallet Balance',
    ja: 'Wallet Balance',
    et: 'Wallet Balance',
    lt: 'Wallet Balance',
    ch: 'Wallet Balance',
    ph: 'Wallet Balance',
  },
  'Wallet ID': {
    en: 'Wallet ID',
    ja: 'Wallet ID',
    et: 'Wallet ID',
    lt: 'Wallet ID',
    ch: 'Wallet ID',
    ph: 'Wallet ID',
  },
  'Wallet Owner': {
    en: 'Wallet Owner',
    ja: 'Wallet Owner',
    et: 'Wallet Owner',
    lt: 'Wallet Owner',
    ch: 'Wallet Owner',
    ph: 'Wallet Owner',
  },
  'Wallet Status': {
    en: 'Wallet Status',
    ja: 'Wallet Status',
    et: 'Wallet Status',
    lt: 'Wallet Status',
    ch: 'Wallet Status',
    ph: 'Wallet Status',
  },
  weekdays: {
    en: 'weekdays',
    ja: '平日',
    et: 'tööpäevad',
    lt: 'weekdays',
    ch: 'weekdays',
    ph: 'weekdays',
  },
  weekends: {
    en: 'weekends',
    ja: '週末',
    et: 'nädalavahetustel',
    lt: 'weekends',
    ch: 'weekends',
    ph: 'weekends',
  },
  'Which session are you attending today?': {
    en: 'Which session are you attending today?',
    ja: 'Which session are you attending today?',
    et: 'Which session are you attending today?',
    lt: 'Which session are you attending today?',
    ch: 'Which session are you attending today?',
    ph: 'Which session are you attending today?',
  },
  'You are checked in! Have fun!': {
    en: 'You are checked in! Have fun!',
    ja: 'You are checked in! Have fun!',
    et: 'You are checked in! Have fun!',
    lt: 'You are checked in! Have fun!',
    ch: 'You are checked in! Have fun!',
    ph: 'You are checked in! Have fun!',
  },
  'I am a ...': {
    en: 'I am a ...',
    ja: 'I am a ...',
    et: 'I am a ...',
    lt: 'I am a ...',
    ch: 'I am a ...',
    ph: 'I am a ...',
  },
  'Let us know who you are!': {
    en: 'Let us know who you are!',
    ja: 'Let us know who you are!',
    et: 'Let us know who you are!',
    lt: 'Let us know who you are!',
    ch: 'Let us know who you are!',
    ph: 'Let us know who you are!',
  },
  'Hello Vivinaut!': {
    en: 'Hello Vivinaut!',
    ja: 'Hello Vivinaut!',
    et: 'Hello Vivinaut!',
    lt: 'Hello Vivinaut!',
    ch: 'Hello Vivinaut!',
    ph: 'Hello Vivinaut!',
  },
  "Let's enter your name in the search box below to locate yourself!": {
    en: "Let's enter your name in the search box below to locate yourself!",
    ja: "Let's enter your name in the search box below to locate yourself!",
    et: "Let's enter your name in the search box below to locate yourself!",
    lt: "Let's enter your name in the search box below to locate yourself!",
    ch: "Let's enter your name in the search box below to locate yourself!",
    ph: "Let's enter your name in the search box below to locate yourself!",
  },
  'Welcome to Vivita – where you belong!': {
    en: 'Welcome to Vivita – where you belong!',
    ja: 'Welcome to Vivita – where you belong!',
    et: 'Welcome to Vivita – where you belong!',
    lt: 'Welcome to Vivita – where you belong!',
    ch: 'Welcome to Vivita – where you belong!',
    ph: 'Welcome to Vivita – where you belong!',
  },
  'Enter your details in the boxes below and get started on your journey with us': {
    en: 'Enter your details in the boxes below and get started on your journey with us',
    ja: 'Enter your details in the boxes below and get started on your journey with us',
    et: 'Enter your details in the boxes below and get started on your journey with us',
    lt: 'Enter your details in the boxes below and get started on your journey with us',
    ch: 'Enter your details in the boxes below and get started on your journey with us',
    ph: 'Enter your details in the boxes below and get started on your journey with us',
  },
  "Visitor's Given Name*": {
    en: "Visitor's Given Name*",
    ja: "Visitor's Given Name*",
    et: "Visitor's Given Name*",
    lt: "Visitor's Given Name*",
    ch: "Visitor's Given Name*",
    ph: "Visitor's Given Name*",
  },
  "Visitor's Family Name": {
    en: "Visitor's Family Name",
    ja: "Visitor's Family Name",
    et: "Visitor's Family Name",
    lt: "Visitor's Family Name",
    ch: "Visitor's Family Name",
    ph: "Visitor's Family Name",
  },
  'Goodbye for now - we hope to see you soon!': {
    en: 'Goodbye for now - we hope to see you soon!',
    ja: 'Goodbye for now - we hope to see you soon!',
    et: 'Goodbye for now - we hope to see you soon!',
    lt: 'Goodbye for now - we hope to see you soon!',
    ch: 'Goodbye for now - we hope to see you soon!',
    ph: 'Goodbye for now - we hope to see you soon!',
  },
  'Click on your name to check out': {
    en: 'Click on your name to check out',
    ja: 'Click on your name to check out',
    et: 'Click on your name to check out',
    lt: 'Click on your name to check out',
    ch: 'Click on your name to check out',
    ph: 'Click on your name to check out',
  },
  'Visualize yourself in the space!': {
    en: 'Visualize yourself in the space!',
    ja: 'Visualize yourself in the space!',
    et: 'Visualize yourself in the space!',
    lt: 'Visualize yourself in the space!',
    ch: 'Visualize yourself in the space!',
    ph: 'Visualize yourself in the space!',
  },
  'Copy and paste list of users to bulk import': {
    en: 'Copy and paste list of users to bulk import',
    ja: 'Copy and paste list of users to bulk import',
    et: 'Copy and paste list of users to bulk import',
    lt: 'Copy and paste list of users to bulk import',
    ch: 'Copy and paste list of users to bulk import',
    ph: 'Copy and paste list of users to bulk import',
  },
  'Copy/Paste User List': {
    en: 'Copy/Paste User List',
    ja: 'Copy/Paste User List',
    et: 'Copy/Paste User List',
    lt: 'Copy/Paste User List',
    ch: 'Copy/Paste User List',
    ph: 'Copy/Paste User List',
  },
  'use a default password for all imported users': {
    en: 'use a default password for all imported users',
    ja: 'use a default password for all imported users',
    et: 'use a default password for all imported users',
    lt: 'use a default password for all imported users',
    ch: 'use a default password for all imported users',
    ph: 'use a default password for all imported users',
  },
  required: {
    en: 'Please enter {{name}}',
    ja: '{{name}}を入力してください',
    et: 'Palun sisestage {{name}}',
    lt: 'Įveskite {{name}}',
    ch: '请输入{{name}}',
    ph: 'Please enter {{name}}',
  },
  invalidPassword: {
    en: 'Password need to be al least 8 character long',
    ja: 'パスワードは8文字以上にする必要があります',
    et: 'Parool peab olema vähemalt 8 tähemärki pikk',
    lt: 'Slaptažodis turi būti bent 8 simbolių ilgio',
    ch: '密码长度必须至少为 8 个字符',
    ph: 'Password need to be al least 8 character long',
  },
  importDescription: {
    en: 'Paste your list of users below. We will import them with auto-generated usernames and passwords. (Up to 1000 entries)',
    ja: 'Paste your list of users below. We will import them with auto-generated usernames and passwords. (Up to 1000 entries)',
    et: 'Paste your list of users below. We will import them with auto-generated usernames and passwords. (Up to 1000 entries)',
    lt: 'Paste your list of users below. We will import them with auto-generated usernames and passwords. (Up to 1000 entries)',
    ch: 'Paste your list of users below. We will import them with auto-generated usernames and passwords. (Up to 1000 entries)',
    ph: 'Paste your list of users below. We will import them with auto-generated usernames and passwords. (Up to 1000 entries)',
  },
  successImportDescription: {
    en: 'All users have been imported!',
    ja: 'All users have been imported!',
    et: 'All users have been imported!',
    lt: 'All users have been imported!',
    ch: 'All users have been imported!',
    ph: 'All users have been imported!',
  },
  'Import List': {
    en: 'Import List',
    ja: 'Import List',
    et: 'Import List',
    lt: 'Import List',
    ch: 'Import List',
    ph: 'Import List',
  },
  confirmDescription: {
    en: 'Please confirm that the infomation below is formatted correctly',
    ja: 'Please confirm that the infomation below is formatted correctly',
    et: 'Please confirm that the infomation below is formatted correctly',
    lt: 'Please confirm that the infomation below is formatted correctly',
    ch: 'Please confirm that the infomation below is formatted correctly',
    ph: 'Please confirm that the infomation below is formatted correctly',
  },
  entryCount_zero: {
    en: 'Total {{count}} entry',
    ja: 'Total {{count}} entry',
    et: 'Total {{count}} entry',
    lt: 'Total {{count}} entry',
    ch: 'Total {{count}} entry',
    ph: 'Total {{count}} entry',
  },
  entryCount_one: {
    en: 'Total {{count}} entry',
    ja: 'Total {{count}} entry',
    et: 'Total {{count}} entry',
    lt: 'Total {{count}} entry',
    ch: 'Total {{count}} entry',
    ph: 'Total {{count}} entry',
  },
  entryCount_other: {
    en: 'Total {{count}} entries',
    ja: 'Total {{count}} entries',
    et: 'Total {{count}} entries',
    lt: 'Total {{count}} entries',
    ch: 'Total {{count}} entries',
    ph: 'Total {{count}} entries',
  },
  duplicateImportMessage_zero: {
    en: 'Unable to create {{count}} user below due to Username conflicts.',
    ja: 'Unable to create {{count}} user below due to Username conflicts.',
    et: 'Unable to create {{count}} user below due to Username conflicts.',
    lt: 'Unable to create {{count}} user below due to Username conflicts.',
    ch: 'Unable to create {{count}} user below due to Username conflicts.',
    ph: 'Unable to create {{count}} user below due to Username conflicts.',
  },
  duplicateImportMessage_one: {
    en: 'Unable to create {{count}} user below due to Username conflicts.',
    ja: 'Unable to create {{count}} user below due to Username conflicts.',
    et: 'Unable to create {{count}} user below due to Username conflicts.',
    lt: 'Unable to create {{count}} user below due to Username conflicts.',
    ch: 'Unable to create {{count}} user below due to Username conflicts.',
    ph: 'Unable to create {{count}} user below due to Username conflicts.',
  },
  duplicateImportMessage_other: {
    en: 'Unable to create {{count}} users below due to Username conflicts.',
    ja: 'Unable to create {{count}} users below due to Username conflicts.',
    et: 'Unable to create {{count}} users below due to Username conflicts.',
    lt: 'Unable to create {{count}} users below due to Username conflicts.',
    ch: 'Unable to create {{count}} users below due to Username conflicts.',
    ph: 'Unable to create {{count}} users below due to Username conflicts.',
  },
  successImportMessage_zero: {
    en: 'Created {{count}} user successfully! Remember to save the username and password for login.',
    ja: 'Created {{count}} user successfully! Remember to save the username and password for login.',
    et: 'Created {{count}} user successfully! Remember to save the username and password for login.',
    lt: 'Created {{count}} user successfully! Remember to save the username and password for login.',
    ch: 'Created {{count}} user successfully! Remember to save the username and password for login.',
    ph: 'Created {{count}} user successfully! Remember to save the username and password for login.',
  },
  successImportMessage_one: {
    en: 'Created {{count}} user successfully! Remember to save the username and password for login.',
    ja: 'Created {{count}} user successfully! Remember to save the username and password for login.',
    et: 'Created {{count}} user successfully! Remember to save the username and password for login.',
    lt: 'Created {{count}} user successfully! Remember to save the username and password for login.',
    ch: 'Created {{count}} user successfully! Remember to save the username and password for login.',
    ph: 'Created {{count}} user successfully! Remember to save the username and password for login.',
  },
  successImportMessage_other: {
    en: 'Created {{count}} users successfully! Remember to save the username and password for login.',
    ja: 'Created {{count}} users successfully! Remember to save the username and password for login.',
    et: 'Created {{count}} users successfully! Remember to save the username and password for login.',
    lt: 'Created {{count}} users successfully! Remember to save the username and password for login.',
    ch: 'Created {{count}} users successfully! Remember to save the username and password for login.',
    ph: 'Created {{count}} users successfully! Remember to save the username and password for login.',
  },
  'Importing Users...': {
    en: 'Importing Users...',
    ja: 'Importing Users...',
    et: 'Importing Users...',
    lt: 'Importing Users...',
    ch: 'Importing Users...',
    ph: 'Importing Users...',
  },
  'Imported User List': {
    en: 'Imported User List',
    ja: 'Imported User List',
    et: 'Imported User List',
    lt: 'Imported User List',
    ch: 'Imported User List',
    ph: 'Imported User List',
  },
  csvMessage: {
    en: 'CSV Export Successfully',
    ja: 'CSV Export Successfully',
    et: 'CSV Export Successfully',
    lt: 'CSV Export Successfully',
    ch: 'CSV Export Successfully',
    ph: 'CSV Export Successfully',
  },
  'Export As CSV': {
    en: 'Export As CSV',
    ja: 'Export As CSV',
    et: 'Export As CSV',
    lt: 'Export As CSV',
    ch: 'Export As CSV',
    ph: 'Export As CSV',
  },
  'Skip Email Verification': {
    en: 'Skip Email Verification',
    ja: 'Skip Email Verification',
    et: 'Skip Email Verification',
    lt: 'Skip Email Verification',
    ch: 'Skip Email Verification',
    ph: 'Skip Email Verification',
  },
  'Create As': {
    en: 'Create As',
    ja: 'Create As',
    et: 'Create As',
    lt: 'Create As',
    ch: 'Create As',
    ph: 'Create As',
  },
  'Amount to Add': {
    en: 'Amount to Add',
    ja: 'Amount to Add',
    et: 'Amount to Add',
    lt: 'Amount to Add',
    ch: 'Amount to Add',
    ph: 'Amount to Add',
  },
  'Amount to Deduct': {
    en: 'Amount to Deduct',
    ja: 'Amount to Deduct',
    et: 'Amount to Deduct',
    lt: 'Amount to Deduct',
    ch: 'Amount to Deduct',
    ph: 'Amount to Deduct',
  },
  'Update Wallet': {
    en: 'Update Wallet',
    ja: 'Update Wallet',
    et: 'Update Wallet',
    lt: 'Update Wallet',
    ch: 'Update Wallet',
    ph: 'Update Wallet',
  },
  Registration: {
    en: 'Registration',
    ja: 'Registration',
    et: 'Registration',
    lt: 'Registration',
    ch: 'Registration',
    ph: 'Registration',
  },
  'Edit & Re-Send Registration Email': {
    en: 'Edit & Re-Send Registration Email',
    ja: 'Edit & Re-Send Registration Email',
    et: 'Edit & Re-Send Registration Email',
    lt: 'Edit & Re-Send Registration Email',
    ch: 'Edit & Re-Send Registration Email',
    ph: 'Edit & Re-Send Registration Email',
  },
  'Bulk Import CSV': {
    en: 'Bulk Import CSV',
    ja: 'Bulk Import CSV',
    et: 'Bulk Import CSV',
    lt: 'Bulk Import CSV',
    ch: 'Bulk Import CSV',
    ph: 'Bulk Import CSV',
  },
  'You booked this session': {
    en: 'You booked this session',
    ja: 'You booked this session',
    et: 'You booked this session',
    lt: 'You booked this session',
    ch: 'You booked this session',
    ph: 'You booked this session',
  },
};
